import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

// API
import * as API  from '../../../../../utils/api'

// Packages
import { Field, FieldArray, reduxForm, initialize } from 'redux-form'

// Form Components
import ReduxFormInput from '../../../../../components/Global/ReduxForms/ReduxFormInput'
import ReduxSelectFormInput from '../../../../../components/Global/ReduxForms/ReduxSelectFormInput'
import ReduxSplitInputContainer from '../../../../../components/Global/ReduxForms/ReduxSplitInputContainer'
import SelectFormInput from '../../../../../components/Global/Forms/SelectFormInput'

// Helpers
import { required } from '../../../../../utils/formValidators'

class LockerProfileForm extends Component {
  static propTypes = {
   onSubmit: PropTypes.func.isRequired,
   participation: PropTypes.object.isRequired
 }

 state = {
   positionDropdownOptions: [],
   selectedPositions: [],
 }

  componentDidMount() {
    this.initializeForm(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.participation.id !== nextProps.participation.id) {
      this.initializeForm(nextProps)
    }
  }

  initializeForm(props) {
    const {
      jersey_number,
      rankings,
      sport_specific_stats,
      sport,
      primary_positions,
    } = props.participation

    let converted_sport_specific_stats = Object.keys(sport_specific_stats).map(metric => {
      return {title: metric, value: sport_specific_stats[metric]}
    })

    let initialFormValues = {
      jersey_number,
      sport_specific_stats: converted_sport_specific_stats,
      rankings
    }

    // Load available sports from API
    API.getSport(sport.id).then(sport => {
      const positionDropdownOptions = sport.positions.map((position) => {
        return {value: position.id, label: position.name}
      })

      this.setState({
        sportPositions: sport.positions,
        positionDropdownOptions,
        selectedPositions: [
          ...primary_positions,
        ]
      })
    })

    this.props.initializeForm(initialFormValues)
  }

  handlePositionAddition = () => {
    const { selectedPositions } = this.state

    this.setState({
      selectedPositions: [
        ...selectedPositions,
        {}
      ]
    })
  }

  handlePositionRemoval = (selectorIndex) => {
    const { selectedPositions } = this.state

    let newSelectedPositions = [
      ...selectedPositions
    ]

    newSelectedPositions = [
      ...newSelectedPositions.slice( 0, selectorIndex ),
      ...newSelectedPositions.slice( selectorIndex + 1, newSelectedPositions.length)
    ]

    this.setState({
      selectedPositions: newSelectedPositions
    })
  }

  handlePositionSelection = (event, positionIndex) => {
    const { value } = event.target
    const {
      selectedPositions,
      sportPositions,
    } = this.state
    // let selectedSports = [...this.state.selectedSports]

    // /////////////////////////////////////////////////
    // // Update Array of Selected Sport Positions
    // let newSelectedPositionsState = [...selectedSports[sportIndex].positions]

    const newPositionSelection = sportPositions.filter((option) => {
      return option.id === parseInt(value, 10)
    }).map(position => {
      return {
        abbreviation: position.abbreviation,
        id: position.id,
        name: position.name
      }
    })[0]

    let newSelectedPositionsState = [
      ...selectedPositions
    ]

    newSelectedPositionsState[positionIndex] = newPositionSelection

    this.setState({
      selectedPositions: newSelectedPositionsState
    })
  }

  handleSubmission = (values) => {
    const { selectedPositions } = this.state

    const selectedPositionsForSubmit = selectedPositions.filter(position => position.hasOwnProperty('id'))

    const positionIds = selectedPositionsForSubmit.map(position => position.id)

    let sport_specific_stats = {}
    values.sport_specific_stats.forEach((metric) => {
      sport_specific_stats[metric['title']] = metric['value']
    })

    const valuesForSubmit = {
      ...values,
      sport_specific_stats,
      rankings: values.rankings,
      primary_position_ids: positionIds,
      primary_positions: selectedPositionsForSubmit,
    }

    this.props.onSubmit(valuesForSubmit)
  }

  render() {
    const { handleSubmit } = this.props
    const { positionDropdownOptions, selectedPositions } = this.state

    return (
      <form
        onSubmit={handleSubmit(this.handleSubmission)}
        className="locker-profile-form"
      >
        <div className="locker-profile-form-base-info">
          <div>
            <label htmlFor="firstName">
              Jersey Number
            </label>
            <Field
              placeholder="Jersey Number"
              name="jersey_number"
              component="input"
              type="text"
            />
          </div>
          <div>
            <label htmlFor="firstName">
              Positions
            </label>
            {
              selectedPositions.map((position, index) => {
                return (
                  <SelectFormInput
                    key={
                      `position-selector-${index}`
                    }
                    name='position'
                    value={position.id || ''}
                    onChange={(event) => this.handlePositionSelection(event, index)}
                    placeholder="Select a position..."
                    selectOptions={positionDropdownOptions}
                    disabled={false}
                    handleInputRemoval={selectedPositions.length > 1 ? () => this.handlePositionRemoval(index) : null}
                  />
                )
              })
            }
            <a
              onClick={this.handlePositionAddition}
              className={`locker-profile-form-add-position${positionDropdownOptions.length <= selectedPositions.length ? ' disabled' : ''}`}
            >
              Add Another Position
            </a>
          </div>
        </div>
        <div className="locker-profile-key-metrics">
          <h2>Key Metrics</h2>
          <p className="note">Key metrics are a great way to highlight your skills and notable positions  related to your sport! For most sports, we recommend adding your primary position as your first key metric. <code>Example: 'Title: Position' and 'Value: QB'</code> or <code>Example: 'Title: Position' and 'Value: Shortstop'</code></p>
          <FieldArray name="sport_specific_stats" component={renderMetrics} />
        </div>
        <div className="locker-profile-rankings">
          <h2>Rankings</h2>
          <p className="note">Rankings are based on a 1-5 star system, and can be used to show off any that might apply to you! <code>Example: 'Institution: Kohls Kicker' and 'Star Rating: 5'</code></p>
          <FieldArray name="rankings" component={renderRankings} />
        </div>
        <button
          className="cta-gradient"
          type="submit"
        >
          Save Changes
        </button>
      </form>
    )
  }
}


const renderMetrics = ({ fields }) => (
  <ul>
    {fields.map((metric, index) => (
      <li key={`metric_${index}`}>
        <ReduxSplitInputContainer>
          <Field
            name={`${metric}.title`}
            type="text"
            component={ReduxFormInput}
            label="Title"
            validate={required}
          />
          <Field
            name={`${metric}.value`}
            type="text"
            component={ReduxFormInput}
            label="Value"
            validate={required}
            handleInputRemoval={() => fields.remove(index)}
          />
        </ReduxSplitInputContainer>
      </li>
    ))}

    <li>
      <button type="button" onClick={() => fields.push({})}>
        + Add a Key Metric
      </button>
    </li>
  </ul>
)

const renderRankings = ({ fields,  }) => (
  <ul>
    {fields.map((ranking, index) => (
      <li key={`ranking_${index}`}>
        <ReduxSplitInputContainer>
          <Field
            name={`${ranking}.institution`}
            type="text"
            component={ReduxFormInput}
            label="Institution"
            validate={required}
          />
          <Field
            name={`${ranking}.stars`}
            type="text"
            component={ReduxSelectFormInput}
            label="Star Rating"
            placeholder="Select a rating"
            selectOptions={[
              {value: 1, label: '1'},
              {value: 2, label: '2'},
              {value: 3, label: '3'},
              {value: 4, label: '4'},
              {value: 5, label: '5'},
            ]}
            validate={required}
            handleInputRemoval={() => fields.remove(index)}
          />
        </ReduxSplitInputContainer>
      </li>
    ))}
    <li>
      <button type="button" onClick={() => fields.push({})}>
        + Add a Ranking
      </button>
    </li>
  </ul>
)

// Connect to redux-form
LockerProfileForm = reduxForm({
  form: 'LockerProfileForm'
})(LockerProfileForm)

const mapDispatchToProps = dispatch => {
  return {
    initializeForm: (data) => {
      dispatch(initialize('LockerProfileForm', data))
    },
  }
}

export default connect(
  null,
  mapDispatchToProps
)(LockerProfileForm)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Locker/LockerScreens/LockerProfileForm/LockerProfileForm.js